import React from "react"
import MHeroCollectionSlider from "../blocks/m_hero_collection_slider"
import MHighlightCarousel from "../blocks/m_highlight_carousel"
import MScienceCarousel from "../blocks/m_science_carousel"
import { useMultiFormatCollection } from "../../hooks/multiFormatCollection"
import { collectionFullSlugPrefixer } from "../../helper/collectionFullSlugPrefixer"

/**
 * This is the switch component for the multi format slider.
 * It ensures the data that is forwarded to the rendering component
 * was handled by the multi format collection hook.
 */
const MMultiFormatSlider = (props) => {
  const { uid } = props.data
  const prefixedCollection = collectionFullSlugPrefixer(props.data.collection)

  const collection = useMultiFormatCollection(
    prefixedCollection,
    props.data.limit,
    props.data.sorting
  )
  const dataCopy = {
    ...props.data,
    collection,
  }
  const componentProps = {
    ...props,
    data: dataCopy,
  }

  // empty result state: totalCount is zero
  if (collection.length === 0) {
    return (
      <section
        className="m-Empty"
        data-info={`MultiFormatSlider: empty local collection in component ${uid}`}
      ></section>
    )
  }

  switch (props.data.slider_type) {
    case "hero-slider":
      return MHeroCollectionSlider(componentProps)
    case "highlight-carousel":
      return MHighlightCarousel(componentProps)
    case "carousel":
    default:
      return MScienceCarousel(componentProps)
  }
}

export default MMultiFormatSlider
